import { observer } from 'mobx-react-lite'
import Tree from 'tree-dnd'

import { TreeRow } from './components/TreeRow'
import { useFilesTreeStore } from 'components/FilesTree/stores/FilesTreeStore'
import { toTree } from 'components/FilesTree/treeUtils'
import { TreeDataItem } from 'components/FilesTree/types'
import { useEffect } from 'react'
import { LocationPickerFolder, SelectedFolder } from 'components/LocationPicker/LocationPicker'

const OFFSET_PER_LEVEL = 20

export const FilesTree = observer(
  ({
    onSelect,
    activeFolder,
    files,
    hideDocs,
    disabledFolderIds = [],
  }: {
    onSelect: (folder: SelectedFolder | null) => void
    activeFolder: LocationPickerFolder | null | undefined
    files: TreeDataItem[]
    hideDocs?: boolean
    disabledFolderIds?: string[]
  }) => {
    const treeStore = useFilesTreeStore()

    useEffect(() => {
      treeStore.setTree(toTree(files, []))
    }, [treeStore, files])

    if (!treeStore.tree) return null

    return (
      <Tree
        tree={treeStore.tree}
        renderItem={(props) => (
          <TreeRow
            {...props}
            onSelect={onSelect}
            activeFolder={activeFolder}
            hideDocs={hideDocs}
            disabledFolderIds={disabledFolderIds}
          />
        )}
        onCollapse={(itemId) => {
          treeStore.onCollapse(itemId)
        }}
        isDragEnabled={false}
        offsetPerLevel={OFFSET_PER_LEVEL}
        isNestingEnabled
        renderDropPlaceholder={() => <div></div>}
      />
    )
  },
)
